exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my_tailored[data-v-a44ff59c]{display:block!important}.is_disabled[data-v-a44ff59c]{color:#9cabc4}.btn_gray[data-v-a44ff59c]{background:gray!important;visibility:hidden!important;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a44ff59c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/order.vue
// module id = 340
// module chunks = 0